import React from "react";

export default function EidAlFitrFrame4({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-eid41{fill:#ff8d29}.cls-eid43{fill:#c6580c}.cls-eid44{fill:#0c0c28}.cls-eid45{fill:#f77514}.cls-eid46{fill:#15133c}"
            }
          </style>
        </defs>
        <path
          d="M1384.32 1660.08H251.27c-82.59 0-149.78-67.19-149.78-149.78V377.26c0-82.59 67.19-149.78 149.78-149.78h1133.05c82.59 0 149.78 67.19 149.78 149.78v1133.05c0 82.59-67.19 149.78-149.78 149.78ZM251.27 271.48c-58.33 0-105.78 47.45-105.78 105.78v1133.05c0 58.33 47.45 105.78 105.78 105.78h1133.05c58.33 0 105.78-47.45 105.78-105.78V377.26c0-58.33-47.45-105.78-105.78-105.78H251.27Z"
          style={{
            fill: "#2b2b68",
          }}
        />
        <path
          d="M1578.68 1197.25h-132.76v-167.72h132.76z"
          className="cls-eid41"
        />
        <path
          d="M1445.78 1034.88v21.09h76.58v146.64h56.18v-167.73h-132.76z"
          className="cls-eid45"
        />
        <path
          d="m1439.7 1222.35 138.02 1.29c21.11-4.23 33.04-11.36 39.01-15.7 3-2.18 5.71-4.84 6.17-8.29.86-6.52-5.2-13.33-15.22-13.33h-185.17c-9.76 0-15.95 6.59-15.25 13.07.31 2.83 2.01 5.11 4.9 7.71 4.82 4.33 13.46 10.72 27.54 15.25Z"
          className="cls-eid46"
        />
        <path
          d="M1407.26 1199.39c.3 2.82 2 5.12 4.89 7.7 4.83 4.33 13.46 10.74 27.55 15.26l138.02 1.29c21.12-4.23 33.05-11.37 39.01-15.7 3-2.18 5.71-4.84 6.16-8.29.28-2.08-.15-4.18-1.17-6.09-1.16 1.95-3.01 3.6-4.99 5.05-5.96 4.33-17.89 11.47-39.01 15.7l-138.02-1.29c-14.09-4.54-22.72-10.94-27.55-15.26-1.6-1.44-2.84-2.78-3.68-4.18-1 1.81-1.42 3.82-1.21 5.81Z"
          className="cls-eid44"
        />
        <path
          d="M1589.44 1608.41h-154.43v-387.67h154.43z"
          className="cls-eid41"
        />
        <path
          d="M1435.02 1220.74v18.66h88.1v369.01h66.32v-387.67h-154.42z"
          className="cls-eid45"
        />
        <rect
          width={145.85}
          height={10.72}
          x={1439.91}
          y={1024.17}
          className="cls-eid44"
          rx={5.36}
          ry={5.36}
          transform="rotate(180 1512.835 1029.525)"
        />
        <path
          d="M1452.82 963.47c9.19-11.95 25.32-21.16 47.62-33.89 4.9-2.8 9.02-4.99 11.8-6.43 2.78 1.44 6.89 3.63 11.8 6.43 22.29 12.73 38.43 21.94 47.62 33.89 3.42 4.45 16.55 23.16 8.83 60.7h-136.48c-7.72-37.54 5.41-56.25 8.83-60.7Z"
          className="cls-eid46"
        />
        <path
          d="M1509.35 905.85c.05-4.91.11-9.81.16-14.72-.75.1-1.72.1-2.41-.48-1.95-1.64-.02-6.65 1.37-11.1 1.27-4.09 2.78-9.91 3.7-17.37.92 7.46 2.43 13.28 3.7 17.37 1.39 4.45 3.32 9.46 1.37 11.1-.69.58-1.66.58-2.41.48.05 4.91.11 9.81.16 14.72.43.27 1.11.78 1.69 1.61.98 1.41 1.76 3.87.56 5.79-.23.36-.79 1.14-2.01 1.69.27 3.59.54 7.19.8 10.78-.6.94-1.19 1.89-1.79 2.83.03 1.09.07 2.19.1 3.28l-1.33-1.34c-.26.41-.52.82-.78 1.24v-2.03c-1.31-1.33-2.62-2.65-3.92-3.98.27-3.59.54-7.19.8-10.78-1.22-.55-1.78-1.33-2.01-1.69-1.2-1.92-.42-4.39.56-5.79.58-.83 1.26-1.33 1.69-1.61Z"
          className="cls-eid46"
        />
        <path
          d="M1443.02 1019.35c.26 1.58.55 3.18.89 4.83h136.49c7.72-37.55-5.42-56.25-8.83-60.7-9.19-11.96-25.33-21.17-47.62-33.9-4.9-2.8-9.02-4.99-11.79-6.43-1.01.53-2.03 1.06-3.04 1.6-7.83 4.16-15.36 8.45-22.6 12.84 5.14 2.19 21.73 10.04 31.68 28.98 12.99 24.76 4.35 48.91 2.9 52.77h-78.07Z"
          className="cls-eid44"
        />
        <path
          d="M1509.28 905.86c.05-4.91.11-9.81.16-14.72-.75.1-1.72.1-2.41-.48-1.95-1.64-.02-6.65 1.37-11.1 1.27-4.09 2.78-9.91 3.7-17.37.92 7.46 2.43 13.28 3.7 17.37 1.39 4.45 3.32 9.46 1.37 11.1-.69.58-1.66.58-2.41.48.05 4.91.11 9.81.16 14.72.43.27 1.11.78 1.69 1.61.98 1.41 1.76 3.87.56 5.79-.23.36-.79 1.14-2.01 1.69.27 3.59.54 7.19.8 10.78-.6.94-1.19 1.89-1.79 2.83.03 1.09.07 2.19.1 3.28l-1.33-1.34c-.26.41-.52.82-.78 1.24v-2.03c-1.31-1.33-2.62-2.65-3.92-3.98.27-3.59.54-7.19.8-10.78-1.22-.55-1.78-1.33-2.01-1.69-1.2-1.92-.42-4.39.56-5.79.58-.83 1.26-1.33 1.69-1.61Z"
          className="cls-eid44"
        />
        <path
          d="M1571.8 1481.73h-33.97v-47.94h33.97zM1492.34 1481.73h-33.97v-47.94h33.97zM1571.8 1567.79h-33.97v-47.94h33.97zM1492.34 1567.79h-33.97v-47.94h33.97z"
          className="cls-eid43"
        />
        <path
          d="M1030.76 1504.78c76.98 170.02 248.12 288.31 446.9 288.31 20.36 0 40.44-1.23 60.14-3.65a486.442 486.442 0 0 0 111.01-27.05c54.74-20.39 104.85-50.29 148.34-87.69 1.5-1.27 2.97-2.56 4.45-3.87a483.693 483.693 0 0 0 32.03-30.88c2.02-2.13 4.02-4.26 5.99-6.43 4.52-4.95 8.95-9.99 13.27-15.12 1.36-1.6 2.7-3.21 4.02-4.84 37.66-45.9 67.16-98.79 86.25-156.4 16.09-48.54 24.8-100.44 24.8-154.37 0-210-132.02-389.16-317.59-459.02 78.34 81.53 126.49 192.26 126.49 314.25 0 80.19-20.8 155.52-57.31 220.88-43.72 78.28-109.95 142.26-189.94 183.2-61.91 31.68-132.06 49.55-206.37 49.55-111.44 0-213.49-40.18-292.46-106.85Z"
          className="cls-eid41"
        />
        <path
          d="M1030.76 1504.78a487.084 487.084 0 0 0 36.32 66.1c82.4 65.17 187.03 104.15 300.91 104.15 78.84 0 153.25-18.67 218.91-51.79 84.85-42.79 155.1-109.69 201.49-191.52 38.72-68.32 60.79-147.06 60.79-230.9 0-126.08-49.94-240.69-131.4-325.63a487.698 487.698 0 0 0-67.4-31.44c78.34 81.53 126.49 192.26 126.49 314.25 0 80.19-20.8 155.52-57.31 220.88-43.72 78.28-109.95 142.26-189.94 183.2-61.91 31.68-132.06 49.55-206.37 49.55-111.44 0-213.49-40.18-292.46-106.85Z"
          className="cls-eid45"
        />
        <path
          d="M1528.95 1602.74c.53 9.66 1.51 19.92 3.07 30.77.3 2.12.62 4.26.97 6.43 17.73-2.29 35.85-4.44 54.33-6.43 48.49-5.23 99.53-9.36 152.96-12 38.7-1.9 76.26-2.9 112.6-3.12 1.36-1.6 2.7-3.21 4.02-4.84 37.66-45.9 67.16-98.79 86.25-156.4-30.68-26.94-79.89-49.22-145.69-79.01-15.85-7.17-29.17-12.79-38.14-16.49-8.97 3.7-22.29 9.32-38.14 16.49-.55.25-1.1.49-1.64.74-83.88 37.98-126.03 57.03-152.34 86.14-8.04 8.9-32.18 38.14-37.6 97.06-1.13 12.24-1.45 25.76-.66 40.65Z"
          className="cls-eid46"
        />
        <path
          d="M1754.82 1335.35c.09-7.85.17-15.7.26-23.56-1.2.16-2.76.16-3.86-.77-3.12-2.63-.03-10.64 2.19-17.76 2.04-6.55 4.45-15.87 5.92-27.8 1.48 11.94 3.88 21.26 5.92 27.8 2.22 7.13 5.31 15.13 2.19 17.76-1.1.93-2.66.93-3.86.77.09 7.85.17 15.7.26 23.56.69.44 1.78 1.25 2.7 2.57 1.57 2.25 2.81 6.19.9 9.27-.36.58-1.27 1.83-3.22 2.7l1.29 17.25c-.96 1.51-1.91 3.02-2.87 4.54.05 1.75.11 3.5.16 5.25l-2.12-2.15c-.42.66-.83 1.32-1.25 1.98v-3.25c-2.09-2.12-4.19-4.24-6.28-6.36l1.29-17.25c-1.95-.87-2.86-2.12-3.22-2.7-1.91-3.08-.67-7.02.9-9.27a9.374 9.374 0 0 1 2.7-2.57Z"
          className="cls-eid46"
        />
        <path
          d="M1681.87 1396.01c44.25 21.03 71.07 36.68 89.83 57.43 8.04 8.9 32.18 38.14 37.6 97.06 1.13 12.24 1.45 25.76.65 40.65-.48 8.81-1.34 18.11-2.68 27.91 15.41-.37 30.62-.59 45.61-.68 1.36-1.6 2.7-3.21 4.02-4.84 37.66-45.9 67.16-98.79 86.25-156.4-30.68-26.94-79.89-49.22-145.69-79.01-15.85-7.17-29.17-12.79-38.14-16.49-8.97 3.7-22.29 9.32-38.14 16.49-.55.25-1.1.49-1.64.74-13.62 6.17-26.15 11.83-37.68 17.12ZM1529.24 1607.42c.57 8.28 1.47 16.97 2.78 26.08.3 2.12.62 4.26.97 6.43 17.73-2.29 35.85-4.44 54.33-6.43 48.49-5.23 99.53-9.36 152.96-12 1.71-.09 3.42-.16 5.12-.24-46.64-4.93-95.63-8.82-146.79-11.34-23.55-1.16-46.69-1.98-69.38-2.51Z"
          className="cls-eid44"
        />
        <path
          d="M1754.82 1335.35c.09-7.85.17-15.7.26-23.56-1.2.16-2.76.16-3.86-.77-3.12-2.63-.03-10.64 2.19-17.76 2.04-6.55 4.45-15.87 5.92-27.8 1.48 11.94 3.88 21.26 5.92 27.8 2.22 7.13 5.31 15.13 2.19 17.76-1.1.93-2.66.93-3.86.77.09 7.85.17 15.7.26 23.56.69.44 1.78 1.25 2.7 2.57 1.57 2.25 2.81 6.19.9 9.27-.36.58-1.27 1.83-3.22 2.7l1.29 17.25c-.96 1.51-1.91 3.02-2.87 4.54.05 1.75.11 3.5.16 5.25l-2.12-2.15c-.42.66-.83 1.32-1.25 1.98v-3.25c-2.09-2.12-4.19-4.24-6.28-6.36l1.29-17.25c-1.95-.87-2.86-2.12-3.22-2.7-1.91-3.08-.67-7.02.9-9.27a9.374 9.374 0 0 1 2.7-2.57ZM1745.4 1621.27c2.07.21 4.12.43 6.17.66 18.49 1.99 36.6 4.13 54.33 6.43.35-2.17.67-4.31.97-6.43.14-.96.28-1.92.39-2.86-20.27.48-40.9 1.21-61.87 2.21Z"
          className="cls-eid44"
        />
        <path
          d="M1528.51 1633.51v41.18h268.65c1.5-1.27 2.97-2.56 4.45-3.87a483.693 483.693 0 0 0 32.03-30.88c2.02-2.13 4.02-4.26 5.99-6.43h-311.11Z"
          className="cls-eid43"
        />
        <path
          d="M1512.3 1621.28c0 5.15 2.09 9.82 5.47 13.18 2.84 2.84 6.56 4.76 10.74 5.3.81.11 1.63.16 2.46.16h302.67c2.02-2.13 4.02-4.26 5.99-6.43 4.52-4.95 8.95-9.99 13.27-15.12 1.36-1.6 2.7-3.21 4.02-4.84-.93-2.04-2.23-3.89-3.79-5.46a18.592 18.592 0 0 0-13.19-5.47h-308.96c-.68 0-1.36.04-2.02.11-9.36 1.01-16.65 8.92-16.65 18.55Z"
          className="cls-eid44"
        />
        <path
          d="M1513.47 1670.82v118.61h24.33a486.442 486.442 0 0 0 111.01-27.05v-91.56h-135.34ZM1648.82 1670.82v91.56c54.74-20.39 104.85-50.29 148.34-87.69 1.5-1.27 2.97-2.56 4.45-3.87h-152.78Z"
          className="cls-eid45"
        />
        <path
          d="M1571.8 1307.61h-33.97v-47.94h33.97zM1492.34 1307.61h-33.97v-47.94h33.97zM1492.34 1169.04h-33.97v-93.37c0-9.37 7.61-16.98 16.98-16.98 9.37 0 16.98 7.61 16.98 16.98v93.37ZM1571.8 1169.04h-33.97v-93.37c0-9.37 7.61-16.98 16.98-16.98 9.37 0 16.98 7.61 16.98 16.98v93.37ZM1571.8 1393.66h-33.97v-47.94h33.97zM1492.34 1393.66h-33.97v-47.94h33.97z"
          className="cls-eid43"
        />
        {children}
      </g>
    </svg>
  );
}
